import { z } from 'zod';
import { useMaxCharacters } from './useMaxCharacters';

export function useOptionalString() {
    const maxCharacters = useMaxCharacters();

    return (max?: number) => {
        const min_object = z.string();

        return maxCharacters(min_object, max).nullish();
    };
}
